import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
import {
  Dic
} from '$utils'
export const tableOption = function (personShow, operateShow) {
  if (personShow) {
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: false,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '110px',
      menuAlign: 'center',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 400,
      dialogWidth: '700px',
      emptyText: '暂无数据',
      column: [{
          label: '人员姓名',
          prop: 'personName',
          align: 'right',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '性别',
          prop: 'sex',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
          dicData: Dic.find('SENU092'),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue('SENU001', Number(value))
            }
            return ''
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue('SENU001', value) : ''
          },
        },
        {
          label: '电话',
          prop: 'phone',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '身份证号',
          prop: 'idCard',
          hide: true,
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '识别时间',
          prop: 'matchTime',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '人员类型',
          prop: 'personnelType',
          type: 'select',
          search: false,
          hide: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          labelWidth: '100px',
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return '员工'
            } else if (Number(value) === 2) {
              return '外来人员'
            }
            return '';
          },
          formatter: (row, value) => {
            if (Number(value) === 1) {
              return '员工'
            } else if (Number(value) === 2) {
              return '外来人员'
            }
            return '';
          },
          dicData: [{
              label: '员工',
              value: 1
            },
            {
              label: '外来人员',
              value: 2
            }
          ],
        },
        {
          label: '外来人员类型',
          prop: 'visitorTypeName',
          hide: true,
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '照片',
          prop: 'fileCode',
          width: 100,
          align: 'center',
          viewDisplay: true,
          viewslot: true,
          span: 24,
        },
        {
          label: '标记',
          prop: 'markType',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
          dicData: [{
              label: '不再提醒',
              value: 1,
            },
            {
              label: '黑名单',
              value: 2,
            },
            {
              label: 'VIP',
              value: 3,
            },
          ],
          formatter: function (row, value) {
            let str = ''
            if (Number(value) == 1) {
              str = '不再提醒'
            }
            if (Number(value) == 2) {
              str = '黑名单'
            }
            if (Number(value) == 3) {
              str = 'VIP'
            }
            return str
          },
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return '不再提醒'
            } else if (Number(value) === 2) {
              return '黑名单'
            } else if (Number(value) === 3) {
              return 'VIP'
            }
            return '';
          },
        },
        {
          label: '允许通行区域',
          prop: 'areaNameStr',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '开始时间',
          prop: 'effectiveTime',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          type: 'datetime',
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '结束时间',
          prop: 'expirationTime',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          type: 'datetime',
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '时间',
          prop: 'time',
          searchSlot: true,
          // type: 'datetimerange',
          // addDisplay: false,
          // editDisplay: false,
          // viewDisplay: false,
          search: true,
          // hide: true,
          // valueFormat: 'timestamp',
          span: 12,
        },
        {
          label: '标记人',
          prop: 'creator',
          align: 'right',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '标记时间',
          prop: 'createTime',
          overHidden: true,
          addDisplay: true,
          editDisplay: true,
          viewDisplay: true,
          span: 12,
          type: 'datetime',
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
      ]
    }
  } else {
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: false,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '110px',
      menuAlign: 'center',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 400,
      dialogWidth: '700px',
      emptyText: '暂无数据',
      column: [{
          label: '车牌号码',
          prop: 'plateNo',
          align: 'right',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '车主姓名',
          prop: 'personName',
          align: 'right',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '性别',
          prop: 'sex',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
          dicData: Dic.find('SENU001'),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue('SENU001', Number(value))
            }
            return ''
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue('SENU001', value) : ''
          },
        },
        {
          label: '电话',
          prop: 'phone',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '身份证号',
          prop: 'idCard',
          hide: true,
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '识别时间',
          prop: 'matchTime',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '人员类型',
          prop: 'personnelType',
          type: 'select',
          search: false,
          hide: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          labelWidth: '100px',
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return '员工'
            } else if (Number(value) === 2) {
              return '外来人员'
            }
            return '';
          },
          formatter: (row, value) => {
            if (Number(value) === 1) {
              return '员工'
            } else if (Number(value) === 2) {
              return '外来人员'
            }
            return '';
          },
          dicData: [{
              label: '员工',
              value: 1
            },
            {
              label: '外来人员',
              value: 2
            }
          ],
        },
        {
          label: '外来人员类型',
          prop: 'visitorTypeName',
          hide: true,
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '照片',
          prop: 'fileCode',
          width: 100,
          align: 'center',
          viewDisplay: true,
          viewslot: true,
          span: 24,
        },
        {
          label: '标记',
          prop: 'markType',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
          dicData: [{
              label: '不再提醒',
              value: 1,
            },
            {
              label: '黑名单',
              value: 2,
            },
            {
              label: 'VIP',
              value: 3,
            },
          ],
          formatter: function (row, value) {
            let str = ''
            if (Number(value) == 1) {
              str = '不再提醒'
            }
            if (Number(value) == 2) {
              str = '黑名单'
            }
            if (Number(value) == 3) {
              str = 'VIP'
            }
            return str
          },
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return '不再提醒'
            } else if (Number(value) === 2) {
              return '黑名单'
            } else if (Number(value) === 3) {
              return 'VIP'
            }
            return '';
          },
        },
        {
          label: '允许通行区域',
          prop: 'areaNameStr',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '开始时间',
          prop: 'effectiveTime',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          type: 'datetime',
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '结束时间',
          prop: 'expirationTime',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          type: 'datetime',
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '时间',
          prop: 'time',
          type: 'datetimerange',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          search: true,
          hide: true,
          valueFormat: 'timestamp',
          span: 12,
        },
        {
          label: '标记人',
          prop: 'creator',
          align: 'right',
          search: false,
          viewDisplay: true,
          span: 12,
          overHidden: true,
        },
        {
          label: '标记时间',
          prop: 'createTime',
          overHidden: true,
          addDisplay: true,
          editDisplay: true,
          viewDisplay: true,
          type: 'datetime',
          span: 12,
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
      ]
    }
  }

}